import { ComponentType, PropsWithChildren } from 'react';

// HOC to pass the plugin configs automatically to the component.
function withConfig<TProps>(
  Comp: ComponentType<PropsWithChildren<TProps>>,
  config: object
) {
  const WrapperComp = (props: TProps) => <Comp {...props} config={config} />;
  const compDisplayName = Comp.displayName || Comp.name || 'Component';
  WrapperComp.displayName = `withConfig(${compDisplayName})`;

  return WrapperComp;
}

export default withConfig;
